<template>
  <PageTemplate :heading="heading" class="objects">
    <div v-if="getHasLandlordProfilesLoaded">
      <div v-if="!hasLandlordNoRentalObject" class="d-flex justify-content-end">
        <router-link
          :to="{ name: 'newRO', params: { landlordId: getLandlordId } }"
          tag="a"
          class="btn btn-sm btn-secondary"
        >
          Nytt leieobjekt
        </router-link>
      </div>

      <template v-if="hasLandlordNoRentalObject">
        <EmptyStates
          :hasLandlordNoRentalObject="hasLandlordNoRentalObject"
          :hasLandlordNoTenancy="hasLandlordNoTenancy"
          class="mt-5"
        />
      </template>

      <template v-else>
        <RentalObjectSmallLandlord
          v-for="(rentalObject, index) in filteredRentalObjects"
          :key="index"
          :landlordId="getLandlordId"
          :rentalObjectId="rentalObject.id"
          :filter="filter"
          class="mt-4"
        />
      </template>
    </div>
  </PageTemplate>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import PageTemplate from '@/components/PageTemplate.vue';
import EmptyStates from '@/components/EmptyStates.vue';
import RentalObjectSmallLandlord from '@/components/single-object/small-landlord/RentalObjectSmallLandlord.vue';

export default Vue.extend({
  name: 'RentalObjects',
  props: {
    filter: {
      type: String,
      required: true,
    },
  },
  components: {
    PageTemplate,
    EmptyStates,
    RentalObjectSmallLandlord,
  },
  computed: {
    ...mapGetters([
      'filteredRentalObjects',
      'getLandlordId',
      'getHasLandlordProfilesLoaded',
      'getLandlordProfilesMeta',
    ]),

    heading() {
      switch (this.filter) {
        case 'all':
          return 'Alle leieobjekter';
        case 'active':
          return 'Leieobjekter med aktive leieforhold';
        case 'cancelled':
          return 'Leieobjekter med avsluttede leieforhold';
        case 'hidden':
          return 'Bare leieobjekter';
        default:
          return '';
      }
    },
    hasLandlordProfilesMetaLoaded() {
      return this.getLandlordProfilesMeta && this.getLandlordProfilesMeta.length > 0;
    },
    hasLandlordNoRentalObject() {
      return this.getLandlordProfilesMeta.find(item => item.id === this.getLandlordId).numberOfRentalObjects === 0;
    },
    hasLandlordNoTenancy() {
      return this.getLandlordProfilesMeta.find(item => item.id === this.getLandlordId).numberOfTenancies === 0;
    },
  },
  watch: {
    filter: {
      async handler(value) {
        if (value === 'all') {
          await this.$store.dispatch('changeDataset', { tenancies: 'active' });
          await this.$store.dispatch('fetchData', {
            tenancies: ['active', 'free', 'resigned'],
            error: () => {
              // We need better error handling (not callback)
              this.$toast('Kunne inne hente utleieobjekter.', 'error');
            },
          });
        } else if (value === 'active') {
          await this.$store.dispatch('changeDataset', { tenancies: 'active' });
          await this.$store.dispatch('fetchData', {
            tenancies: ['active', 'free'],
            error: () => {
              this.$toast('Kunne inne hente utleieobjekter.', 'error');
            },
          });
        } else if (value === 'cancelled') {
          await this.$store.dispatch('changeDataset', { tenancies: 'resigned' });
          await this.$store.dispatch('fetchData', {
            tenancies: ['resigned'],
            error: () => {
              this.$toast('Kunne inne hente utleieobjekter.', 'error');
            },
          });
        }
      },
      immediate: true,
    },
  },
});
</script>
